<template>
  <svg xmlns="http://www.w3.org/2000/svg" 
    :width="width" 
    :height="height" 
    viewBox="0 0 819 1024" 
    :aria-labelledby="iconName" 
    role="presentation"
  >
    <title :id="iconName" lang="en">{{iconName}} icon</title>    
<g id="icomoon-ignore">
</g>
<g fill="#0000" :stroke="iconColor" stroke-width="50">
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M735.253 613.767v108.552c0 7.496-6.074 13.567-13.567 13.567v0h-37.314c-8.848 0-16.706 4.235-21.663 10.789l-0.050 0.070-38.672 51.564c-2.501 3.312-6.43 5.429-10.854 5.429v0h-419.895c0 0 0 0 0 0-4.833 0-9.076-2.528-11.48-6.328l-0.031-0.056-30.38-48.686c-4.874-7.719-13.356-12.77-23.023-12.77 0 0 0 0 0 0h-30.811c-7.496 0-13.567-6.074-13.567-13.567v0-108.552z"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M233.201 803.734v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M301.047 803.734v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M368.896 803.734v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M436.736 803.734v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M504.583 803.734v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M572.429 803.734v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M233.201 640.904v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M165.355 640.904v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M301.047 640.904v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M368.896 640.904v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M436.736 640.904v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M504.583 640.904v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M572.429 640.904v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M640.272 640.904v-27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M219.633 708.751h379.933"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M83.947 613.767l51.18-153.548c1.85-5.436 6.912-9.277 12.872-9.277h523.2c5.959 0 11.021 3.841 12.845 9.181l0.027 0.095 51.18 153.548"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M246.77 138.851l65.299-97.955c9.871-14.657 26.405-24.171 45.161-24.171 0 0 0 0 0 0h104.733c0 0 0 0 0 0 18.756 0 35.29 9.515 45.037 23.978l0.122 0.193 65.299 97.955"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M735.253 695.183h27.137c22.483 0 40.704-18.225 40.704-40.704v0-284.95h-787.003v284.95c0 22.483 18.225 40.704 40.704 40.704v0h27.137"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M803.101 369.527l-93.885-199.509c-8.886-18.568-27.526-31.164-49.112-31.164h-501.008c-21.581 0-40.221 12.597-48.966 30.84l-0.141 0.324-93.885 199.509"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M287.479 84.579h54.278"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" d="M527.242 71.006h-63.369"></path>
</g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'IconHdmi'
    },
    width: {
      type: [Number, String],
      default: 50 
    },
    height: {
      type: [Number, String],
      default: 50
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>